export const INSTRUMENT_DEVICE_LIST = '/rest/tt/deviceList'
export const GET_NPS_URL = '/rest/tt/getNpsUrl'
export const CHECK_CLIENT_COBRANDING = '/rest/tt/checkForClientBanding?assignmentId=11814781'
export const GET_ACCESSIBILTY_STATUS = '/rest/tt/accssibilityStatus'
export const GET_CANDIDATE_CHECK = '/rest/tt/getCandidateCheck'
export const GET_TEST_INFO = '/rest/tt/test'
export const GET_CANDIDATE_LIST = '/rest/tt/candidateList'
export const GET_CANDIDATE_USER_DETAILS = '/rest/tt/user';
export const QUALTRICS_REGISTRATION = '/rest/tt/candidateRegAtQualtrics';
export const TEST_QUESTIONS = '/rest/tt/questionp/';
export const TEST_COMPLETE = '/rest/tt/tresult/';
export const PREVIEW_TEST = '/rest/tt/previewWelcome';
export const AUDIO_FAILED = '/rest/tt/audio/';
export const GET_ENCRYPTED_DATA = '/rest/tt/getEncryptedData/';
export const GET_SCORM_DATA = '/rest/tt/scorm/';
export const GET_PREVIEW_TEST = '/rest/tt/previewtest';
export const UPDATE_INTERSTITIAL_STATUS = '/rest/tt/updateInterstitialStatus/';
export const POST_DEMOGRAPHIC_DATA = '/rest/tt/demographic';
export const SYSCHECK_PHRASES = '/rest/pharases/syscheckPhrases/';
export const QUESTIONS_ANSWERED = '/rest/tt/getNumberOfQuestionAnswered';
export const SCORE_REUSE_ELIGIBILITY = '/rest/tt/resultReuseEligibility/';
export const REUSE_RESPONSES = '/rest/tt/reuseResponses';
export const TIMER_VALUE = '/rest/tt/timer';
